var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useEffect, useState, useRef } from "react";
import styled from "styled-components";
import TextInput from "../text";
import { Calendar } from "./calendar";
import { BsCalendar } from "@react-icons/all-files/bs/BsCalendar";
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var DateInput = function (_a) {
    var year = _a.year, month = _a.month, day = _a.day, label = _a.label, name = _a.name, placeholder = _a.placeholder, _b = _a.format, format = _b === void 0 ? "mm/dd/yyyy" : _b, _c = _a.seperator, seperator = _c === void 0 ? "/" : _c, onChange = _a.onChange;
    var calendarRef = useRef(null);
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var _e = useState(new Date(year, month, day)), currValue = _e[0], setValue = _e[1];
    var _f = useState("".concat(month + 1 > 9 ? month + 1 : "0".concat(month + 1)).concat(seperator).concat(day > 9 ? day : "0".concat(day)).concat(seperator).concat(year)), displayValue = _f[0], setDisplay = _f[1];
    useEffect(function () {
        setValue(new Date(year, month, day));
        setDisplay("".concat(month + 1 > 9 ? month + 1 : "0".concat(month + 1)).concat(seperator).concat(day > 9 ? day : "0".concat(day)).concat(seperator).concat(year));
    }, [year, month, day, seperator]);
    var openCalendar = useCallback(function () {
        console.log("open");
        setOpen(true);
        if (calendarRef.current) {
            console.log(calendarRef);
            calendarRef.current.focus();
        }
    }, []);
    var closeCalendar = useCallback(function () {
        console.log("close");
        setOpen(false);
    }, []);
    var toggleCalendar = useCallback(function () {
        if (open) {
            closeCalendar();
        }
        else {
            openCalendar();
        }
    }, [open, openCalendar, closeCalendar]);
    var handleChange = useCallback(function (date, e) {
        setValue(date);
        if (onChange) {
            onChange({
                event: e,
                data: {
                    date: date,
                    year: date.getFullYear(),
                    month: date.getMonth(),
                    day: date.getDate(),
                    value: displayValue,
                    name: name,
                },
            });
        }
        closeCalendar();
    }, [onChange, displayValue, closeCalendar, name]);
    var handleTextChange = useCallback(function (e) {
        var value = e.target.value;
        if (typeof value === "string") {
            if (value.length < displayValue.length) {
                setDisplay(value);
            }
            else {
                var invalidCharacters = void 0;
                switch (value.length) {
                    case 2:
                    case 5:
                        invalidCharacters = new RegExp("[^0-9".concat(seperator, "]"), "g");
                        break;
                    case 3:
                    case 6:
                        invalidCharacters = new RegExp("[^".concat(seperator, "]"), "g");
                        break;
                    default:
                        invalidCharacters = new RegExp("[^0-9]", "g");
                        break;
                }
                var display = value;
                if (value.length > 0 && invalidCharacters.test(value.substring(value.length - 1, value.length))) {
                    display = value.substring(0, value.length - 1);
                }
                if (display.substring(display.length - seperator.length, display.length) === seperator ||
                    display.length === format.length) {
                    display = display
                        .split(seperator)
                        .map(function (part) { return (part.length === 1 ? "0".concat(part) : part); })
                        .join(seperator);
                }
                if (display.length === 2 || display.length === 5) {
                    display += seperator;
                }
                setDisplay(display.substring(0, format.length));
                if (display.length === 10) {
                    var month_1 = parseInt(display.substring(0, 2));
                    var day_1 = parseInt(display.substring(3, 5));
                    var year_1 = parseInt(display.substring(6, 10));
                    var isValidMonth = month_1 > 0 && month_1 < 13;
                    var isValidDay = day_1 > 0 && day_1 < 32;
                    var isValidYear = year_1 > 1900 && year_1 < 2100;
                    console.log({ month: month_1, day: day_1, year: year_1, isValidDay: isValidDay, isValidMonth: isValidMonth, isValidYear: isValidYear });
                    if (isValidMonth && isValidDay && isValidYear) {
                        setValue(new Date(year_1, month_1 - 1, day_1));
                    }
                }
            }
        }
    }, [format.length, seperator, displayValue]);
    return (React.createElement(Wrapper, null,
        React.createElement(TextInput, { value: displayValue, label: label, placeholder: placeholder, onChange: handleTextChange },
            React.createElement(BsCalendar, { onClick: toggleCalendar })),
        open && (React.createElement("div", { ref: calendarRef },
            React.createElement(Calendar, { value: currValue, onChange: handleChange })))));
};
export default DateInput;
var templateObject_1;
